export const priceFormatter = (number) => {
  if (typeof number === "number") {
    number = number.toString();
  } else if (isNaN(number)) {
    return numberFormatter(number);
  }
  return number?.replace(/\D/g, "")?.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

export const numberFormatter = (value) => {
  if (!value || typeof value === "object") return "";
  const replaceValue = value.toString().replace(/\D/g, "");
  return !replaceValue.length ? "" : new Intl.NumberFormat("tr-TR").format(replaceValue);
};
